import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService, GRSSUserRoles, ValueIdPair } from 'src/app/_services/app.service';
import { ManageGeneralMarketsComponent } from '../manage-general-markets.component';



@Component({
    selector: 'app-add-instrument',
    templateUrl: './add-instrument.component.html',
    styleUrls: ['./add-instrument.component.scss'],
    standalone: false
})
export class AddInstrumentComponent implements OnInit {

  instrument: Instrument;
  calculationTypes: ValueIdPair[] = [{id: '0', value: 'Default'}];
  futuresTypes: ValueIdPair[] = [];
  forwardLookingRates: ValueIdPair[] = [];
  calDecPlacesItem: string = '0';
  conDecPlacesItem: string = '0';
  minVolItem: string = '0';
  
  operatorRoleName: string = GRSSUserRoles.Operator;
  local: string = 'en-US';

  isTransactional: boolean = false;

  constructor(public service: AppService, public dialogRef: MatDialogRef<ManageGeneralMarketsComponent>, @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit() {
    this.InitializeForm();
    if (this.service.isUpdateInstrument === true) {
      this.PopulateForm();
    }
  }

  /** Initializes the form */
  InitializeForm() {
    this.isTransactional = this.data.isTransactional;
    this.calculationTypes = this.calculationTypes.concat(this.data.calTypes);
    this.futuresTypes = this.data.futuresTypes;
    this.forwardLookingRates = this.data.forwardLookingRates;
    this.instrument = {
      instrumentId: '',
      listFuturesID: '',
      forwardLookingRates: [],
      code: '',
      description: '',
      instrumentTypes: [],
      term: null,
      calculationType: {id: '0', value: 'Default'},
      contributionDecimalPlaces: 0,
      calculationDecimalPlaces: 0,
      spread: 0,
      refixTolerance: 0,
      spikeTolerance: 0,
      d1SpikeTolerance: 0,
      dynamicSpikeTolerance: 0,
      dynamicSpikeToleranceBuffer: 0,
      staticMovementTolerance: 0,
      relativeMovementTolerance: 0,
      contributionDeviationTolerance: 0,
      bucketLeft: 0,
      bucketRight: 0,
      minimumVolume: 0
    };
    this.local = this.service.getLocalLanguage();
  }

  // OnStepperFocus(event: any) {
  //   const stepper = event.target.parentElement.parentElement.children[1].children[0];
  //   if (stepper) {
  //     if (stepper.classList.includes('stepper') && stepper.style.display !== 'block') {
  //       stepper.style.display = 'block';
  //     }
  //   }
  // }

  OnStepperClick() {
    const number = '00000';
    // if (direction > 0) {
    //   number = number + Number(step);
    // } else {
    //   number = number - Number(step);
    // }
  }

  /** Populates the form */
  PopulateForm() {
    this.instrument = {
      instrumentId: this.data.instrument.instrumentId,
      listFuturesID: this.data.instrument.listFuturesID,
      forwardLookingRates: this.data.instrument.forwardLookingRates,
      instrumentTypes: this.data.instrument.instrumentTypes,
      code: this.data.instrument.code,
      description: this.data.instrument.description,
      term: this.data.instrument.term,
      calculationType: this.data.instrument.calculationType,
      contributionDecimalPlaces: this.data.instrument.contributionDecimalPlaces,
      calculationDecimalPlaces: this.data.instrument.calculationDecimalPlaces,
      spread: this.data.instrument.spread,
      refixTolerance: this.data.instrument.refixTolerance,
      spikeTolerance: this.data.instrument.spikeTolerance,
      d1SpikeTolerance: this.data.instrument.d1SpikeTolerance,
      dynamicSpikeTolerance: this.data.instrument.dynamicSpikeTolerance,
      dynamicSpikeToleranceBuffer: this.data.instrument.dynamicSpikeToleranceBuffer,
      staticMovementTolerance: this.data.instrument.staticMovementTolerance,
      relativeMovementTolerance: this.data.instrument.relativeMovementTolerance,
      contributionDeviationTolerance: this.data.instrument.contributionDeviationTolerance,
      bucketLeft: this.data.instrument.bucketLeft,
      bucketRight: this.data.instrument.bucketRight,
      minimumVolume: this.data.instrument.minimumVolume
    };

    if (this.instrument.contributionDecimalPlaces) {
      this.conDecPlacesItem = '1';
    } else {
      this.instrument.contributionDecimalPlaces = 0;
    }

    if (this.instrument.calculationDecimalPlaces) {
      this.calDecPlacesItem = '1';
    } else {
      this.instrument.calculationDecimalPlaces = 0;
    }

    if (this.instrument.minimumVolume) {
      this.minVolItem = '1';
    } else {
      this.instrument.minimumVolume = 0;
    }
  }

  /** Save button event */
  OnSaveInstrument() {
    if (this.instrument.code !== '' && this.instrument.description !== '' && this.instrument.term !== null) {
      const tempCal = this.calculationTypes.filter(o => o.id === this.instrument.calculationType.id)[0];
      this.instrument.calculationType.id = tempCal.id;
      this.instrument.calculationType.value = tempCal.value;

      if (Number(this.conDecPlacesItem) === 0) {
        this.instrument.contributionDecimalPlaces = null;
      }

      if (Number(this.calDecPlacesItem) === 0) {
        this.instrument.calculationDecimalPlaces = null;
      }
      
      if (Number(this.minVolItem) === 0) {
        this.instrument.minimumVolume = null;
      }

      this.dialogRef.close(this.instrument);
      this.service.isUpdateInstrument = false;
    }
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }

}

/** Interface for access instrument details */
interface Instrument {
  instrumentId: string;
  listFuturesID: string;
  forwardLookingRates: string[];
  code: string;
  description: string;
  instrumentTypes: string[];
  term: number;
  calculationType: ValueIdPair;
  contributionDecimalPlaces: number;
  calculationDecimalPlaces: number;
  spread: number;
  refixTolerance: number;
  spikeTolerance: number;
  d1SpikeTolerance: number;
  dynamicSpikeTolerance: number;
  dynamicSpikeToleranceBuffer: number;
  staticMovementTolerance: number;
  relativeMovementTolerance: number;
  contributionDeviationTolerance: number;
  bucketLeft: number;
  bucketRight: number;
  minimumVolume: number;
}
